import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.homeBusiness.address',
        defaultMessage: 'Address'
    },
    atResidencePremisesHeader: {
        id: 'ml.quoteandbind.homeBusiness.atResidencePremises',
        defaultMessage: 'At Residence Premises'
    },
    isBusinessCondAtResPrem: {
        id: 'ml.quoteandbind.homeBusiness.isBusinessCondAtResPrem',
        defaultMessage: 'Is this Business conducted at the residence premises?'
    },
    businessName: {
        id: 'ml.quoteandbind.homeBusiness.businessName',
        defaultMessage: 'Business Name'
    },
    businessType: {
        id: 'ml.quoteandbind.homeBusiness.businessType',
        defaultMessage: 'Business Type'
    },
    doesBusinessReqPhyAlterToDwelling: {
        id: 'ml.quoteandbind.homeBusiness.doesBusinessReqPhyAlterToDwelling',
        defaultMessage: 'Does the Business require any physical alteration to the Dwelling?'
    },
    doesBusinessEmployAssistant: {
        id: 'ml.quoteandbind.homeBusiness.doesBusinessEmployAssistant',
        defaultMessage: 'Does the Business employ an assistant?'
    },
    isBusinessCondByOtherThanNamedIns: {
        id: 'ml.quoteandbind.homeBusiness.isBusinessCondByOtherThanNamedIns',
        defaultMessage: 'Is this Business conducted by someone other than Named Insured?'
    },
    separateStructureDescription: {
        id: 'ml.quoteandbind.homeBusiness.separateStructureDescription',
        defaultMessage: 'Separate Structure Description'
    },
    numberOfEmployees: {
        id: 'ml.quoteandbind.homeBusiness.numberOfEmployees',
        defaultMessage: 'Number of Employees'
    },
    businessPursuitsInSeparateStructuresOnPrem: {
        id: 'ml.quoteandbind.homeBusiness.businessPursuitsInSeparateStructuresOnPrem',
        defaultMessage: 'Business Pursuits In separate structure on the Premises'
    },
    doesBusinessConsistOfHomeCare: {
        id: 'ml.quoteandbind.homeBusiness.doesBusinessConsistOfHomeCare',
        defaultMessage: 'Does the business consist of any home care services?'
    },
    action: {
        id: 'ml.quoteandbind.homeBusiness.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.homeBusiness.modalTitle',
        defaultMessage: 'Add Home Business'
    },
    addressLine1: {
        id: 'ml.quoteandbind.homeBusiness.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.homeBusiness.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.homeBusiness.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.homeBusiness.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.homeBusiness.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.homeBusiness.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.homeBusiness.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.homeBusiness.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.homeBusiness.continueBtn',
        defaultMessage: 'Continue'
    },
});
